class EventService {
  static _subscribersCount = 0;
  _events = {};

  emit(event) {
    const subscribers = this._events[event] || [];
    subscribers.forEach((subscriber) => subscriber.action());
  }

  subscribe(event, action) {
    const id = this._generateId();

    if (!this._events[event]) {
      this._events[event] = [];
    }

    this._events[event].push({
      id,
      action,
    });

    return id;
  }

  unsubscribe(event, id) {
    const subscribers = this._events[event];

    if (!subscribers) {
      throw new Error('Event does not exist');
    }

    const remaining = subscribers.filter((subscriber) => subscriber.id !== id);
    this._events[event] = remaining;
  }

  _generateId() {
    this._subscribersCount += 1;

    return this._subscribersCount;
  }
}

const singletonEventService = new EventService();

export default singletonEventService;
